import { classics } from "@/mocks/content";

export default function ClassicsSection() {
  return (
    <section id="classics" className="bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-primary-600">
            <i className="ri-award-line"></i>
            经典必看
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            经得起反复看的经典剧目
          </h2>
          <p className="mt-3 text-sm leading-7 text-foreground-700">
            热门新剧适合紧跟话题，而经典老剧适合慢慢回味。下面这几部的类型跨度较大，
            覆盖古装励志、纯爱、悬疑推理、现实治愈与职场写实，可以按心情挑选。
          </p>
        </div>

        <div className="mt-9 grid gap-6 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="relative h-72 w-full overflow-hidden rounded-lg bg-background-200 lg:h-full">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20nostalgic%20scene%20of%20old%20film%20reels%20and%20stacked%20drama%20posters%20on%20a%20wooden%20shelf%20with%20soft%20window%20light%2C%20warm%20amber%20and%20cream%20tones%2C%20cozy%20retro%20atmosphere%2C%20minimal%20tidy%20composition%2C%20editorial%20photography%20style%2C%20high%20detail&width=900&height=1200&seq=hdrama-classic-01&orientation=portrait"
                alt="经典韩剧回顾的怀旧氛围配图"
                title="经典韩剧必看推荐"
                className="h-full w-full object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/55 via-transparent to-transparent"></div>
              <div className="absolute bottom-5 left-5 right-5">
                <p className="text-xs font-medium text-background-50/90">经典回顾</p>
                <p className="mt-1 font-heading text-lg font-bold text-background-50">
                  从 2000 年代到近年，一代人的荧幕记忆
                </p>
              </div>
            </div>
          </div>

          <ul className="lg:col-span-3">
            {classics.map((item) => (
              <li
                key={item.rank}
                className="flex gap-4 border-b border-background-200 py-4 last:border-b-0 first:pt-0"
              >
                <span className="font-heading text-2xl font-bold text-background-400">{item.rank}</span>
                <div className="flex-1">
                  <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                    <h3 className="font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                    <span className="text-xs text-foreground-600">{item.year}</span>
                    <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-xs text-accent-900">
                      {item.genre}
                    </span>
                  </div>
                  <p className="mt-2 text-sm leading-6 text-foreground-700">{item.reason}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}